const map = {
	"./sobrevivente-de-guerra/slides/slide-1.png": 5091,
	"./sobrevivente-de-guerra/slides/slide-2.png": 9480,
	"./sobrevivente-de-guerra/slides/slide-3.png": 609,
	"./sobrevivente-de-guerra/slides/slide-4.png": 2126
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1135;